import VueI18n from 'vue-i18n';
import { RawLocation, Route } from 'vue-router';
import { Routes } from '@front-app/constants/routes';
import { EventListQuery } from '@front-app/router/util/eventListQuery';
import { getAsArray } from '@front-app/router/util/getFromRequest';
import { DEFAULT_EVENT_FILTERS, EventFilter } from '@front-app/views/home/events/EventEnum';
import { PhoenixRouteConfig } from '@front-app/router/Model';

export const events: PhoenixRouteConfig[] = [
	{
		meta: {
			title(i18n: VueI18n): string {
				// TODO: Add group title here as well, somehow
				return i18n.t('events.event') as string;
			},
			trappRoute(to: Route): string {
				return `/fvgbd.shtml?gd=${to.params.eventId}`;
			},
			loginRoute(to: Route): RawLocation {
				return {
					name: Routes.GROUP_EVENT_LOGIN,
					params: to.params,
				};
			},
		},
		path: 'events/:eventId/',
		name: Routes.GROUP_EVENT,
		// eslint-disable-next-line @typescript-eslint/no-explicit-any
		props(route: Route): any {
			return {
				eventId: route.params.eventId,
			};
		},
		component: () => import(/* webpackChunkName: "event" */ '@front-app/views/home/Event.vue'),
	},
	{
		meta: {
			title(i18n: VueI18n): string {
				return i18n.t('group.tabs.events') as string;
			},
			trappRoute(to: Route): string {
				return `/svpf.shtml?hcgd=${to.params.groupId}`;
			},
		},
		path: 'events',
		name: Routes.GROUP_EVENTS,
		component: () => import(/* webpackChunkName: "group_events" */ '@front-app/views/home/group/GroupEvents.vue'),
		// eslint-disable-next-line @typescript-eslint/no-explicit-any
		props(route: Route): any {
			const requestedFilters = (getAsArray(route.query[EventListQuery.FILTERS]) as EventFilter[])
				.filter((filter) => Object.values(EventFilter).includes(filter));
			const currentAccessFilters = requestedFilters.length > 0 ? requestedFilters : DEFAULT_EVENT_FILTERS;
			const currentTopicFilters = getAsArray(route.query[EventListQuery.TOPIC]);
			const currentTypeFilters = getAsArray(route.query[EventListQuery.TYPE]);
			return {
				currentTypeFilters,
				currentTopicFilters,
				currentAccessFilters,
			};
		},
	},
];
